import { render, staticRenderFns } from "./bkGoOnAddOtherCompContract.vue?vue&type=template&id=06ac1f4a"
import script from "./bkGoOnAddOtherCompContract.vue?vue&type=script&lang=js"
export * from "./bkGoOnAddOtherCompContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports